import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import { hasPermission } from "../../common/helpers";

/**
 * List of all the admins.
 *
 * @param dispatch
 * @param commit
 * @param [payload]
 * @param  [role]
 * @returns {*}
 */
export function getAdmins(_ref, payload) {
  var dispatch = _ref.dispatch,
    commit = _ref.commit,
    rootGetters = _ref.rootGetters;
  var user = rootGetters['auth/user'];
  if (hasPermission(user, 'read:admins')) {
    return dispatch('api', {
      url: 'users',
      wait: 'get-admins',
      params: {
        role: (payload === null || payload === void 0 ? void 0 : payload.role) || null,
        files: true
      }
    }, {
      root: true
    }).then(function (response) {
      !(payload !== null && payload !== void 0 && payload.role) && commit('SET', response.data);
      return Promise.resolve(response);
    });
  }
  commit('SET', {
    data: [user]
  });
}